import React, { createContext, PropsWithChildren, useState } from 'react';
import { Selected } from '../../components/filter/props';
import { FilterHeaderInputValues } from '../../components/filterHeader/props';

export type FilterProps = {
  arr: Selected[];
  filtered: Selected[];
  isOnInit: boolean;
  facet: string;
};

type MyContextData = {
  department: FilterProps;
  setDepartment: React.Dispatch<React.SetStateAction<FilterProps>>;
  categories: FilterProps;
  setCategories: React.Dispatch<React.SetStateAction<FilterProps>>;
  locations: FilterProps;
  setLocations: React.Dispatch<React.SetStateAction<FilterProps>>;
  brand: FilterProps;
  setBrand: React.Dispatch<React.SetStateAction<FilterProps>>;
  removeChips: (
    arr: Selected[],
    method: React.Dispatch<React.SetStateAction<FilterProps>>,
    removeAll: boolean,
    label?: string
  ) => Selected[];
  removeAllChips: () => void;
  term: FilterHeaderInputValues;
  setTerm: React.Dispatch<React.SetStateAction<FilterHeaderInputValues>>;
  location: FilterHeaderInputValues;
  setLocation: React.Dispatch<React.SetStateAction<FilterHeaderInputValues>>;
};

export const FilterContext = createContext<MyContextData>({} as MyContextData);

export const FilterContextProvider = ({ children }: PropsWithChildren) => {
  const departmentFacet = 'cf_department';
  const categoriesFacet = 'cf_category';
  const locationsFacet = 'location_city';
  const brandFacet = 'cf_brand';

  const getValue = (isOnInit: boolean, field?: string): FilterProps => {
    return {
      arr: [],
      filtered: [],
      isOnInit: isOnInit,
      facet: field,
    } as FilterProps;
  };

  const [department, setDepartment] = useState<FilterProps>(
    getValue(true, departmentFacet)
  );
  const [categories, setCategories] = useState<FilterProps>(
    getValue(true, categoriesFacet)
  );
  const [locations, setLocations] = useState<FilterProps>(
    getValue(true, locationsFacet)
  );
  const [brand, setBrand] = useState<FilterProps>(getValue(true, brandFacet));
  const [term, setTerm] = useState<FilterHeaderInputValues>({
    value: '',
    isOnInit: true,
  });
  const [location, setLocation] = useState<FilterHeaderInputValues>({
    value: '',
    isOnInit: true,
  });

  const removeChips = (
    arr: Selected[],
    setStateAction: React.Dispatch<React.SetStateAction<FilterProps>>,
    removeAll: boolean,
    label?: string
  ): Selected[] => {
    const newArr = removeAll ? [] : arr.filter((e: any) => e.value !== label);

    setStateAction((prevState) => ({
      ...prevState,
      arr: newArr,
      filtered: newArr,
    }));
    return newArr;
  };

  const removeAllChips = () => {
    setDepartment(getValue(false, departmentFacet));
    setCategories(getValue(false, categoriesFacet));
    setLocations(getValue(false, locationsFacet));
    setBrand(getValue(false, brandFacet));
  };

  const contextValue = {
    department,
    setDepartment,
    categories,
    setCategories,
    locations,
    setLocations,
    brand,
    setBrand,
    removeChips,
    removeAllChips,
    term,
    setTerm,
    location,
    setLocation,
  };

  return (
    <FilterContext.Provider value={contextValue}>
      {children}
    </FilterContext.Provider>
  );
};
